import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🐶", key: "dog" },
  { emoji: "🐱", key: "cat" },
  { emoji: "🐰", key: "smallPet" },
  { emoji: "🐾", key: "multiple" },
]

export default function PetsStartHerePage() {
  return <RadioCardListPage translationKey="petsStartHere" options={OPTIONS} />
}
